module.exports = __webpack_public_path__ + "images/emoji/new_moon_with_face.c12d948dcec1179f0a8d.png";